import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Combobox from "@/components/Combobox";
import DateField from "@/components/DateField";
import { INDONESIA_REGIONS, PROVINCES } from "@/lib/indonesia";

/** Main-Contract (new_project) fields for EditProjectDialog. */
export default function EditNewProjectFields({ form, setForm, clientOptions }) {
  return (
    <>
      <div className="space-y-1.5">
        <Label className="overline text-slate-600">Project Name</Label>
        <Input data-testid="edit-proj-name" required value={form.project_name} onChange={(e) => setForm({ ...form, project_name: e.target.value })} className="rounded-none" />
      </div>
      <div className="space-y-1.5">
        <Label className="overline text-slate-600">Client</Label>
        <Input
          data-testid="edit-proj-client"
          required
          value={form.client}
          onChange={(e) => setForm({ ...form, client: e.target.value })}
          list="edit-existing-client-suggestions"
          autoComplete="off"
          className="rounded-none"
        />
        <datalist id="edit-existing-client-suggestions">
          {clientOptions.map((c) => (
            <option key={c} value={c} />
          ))}
        </datalist>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">Province</Label>
          <Combobox
            testid="edit-proj-province"
            value={form.province}
            onChange={(v) => setForm({ ...form, province: v, city: form.province === v ? form.city : "" })}
            options={PROVINCES}
            placeholder="Select province…"
          />
        </div>
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">City / Regency</Label>
          <Combobox
            testid="edit-proj-city"
            value={form.city}
            onChange={(v) => setForm({ ...form, city: v })}
            options={form.province ? INDONESIA_REGIONS[form.province] || [] : []}
            placeholder={form.province ? "Select city…" : "Pick province first"}
            disabled={!form.province}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">Start Date</Label>
          <DateField testid="edit-proj-start" value={form.start_date} onChange={(v) => setForm({ ...form, start_date: v })} />
        </div>
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">End Date</Label>
          <DateField testid="edit-proj-end" value={form.end_date} onChange={(v) => setForm({ ...form, end_date: v })} />
        </div>
      </div>
    </>
  );
}
